<script setup>
import { ref, onMounted } from 'vue'
import levelupCard from './levelupCard.vue'
import { humanizeText } from '@/helper';

const props = defineProps({
  notification: {
    type: Object
  }
})

const isLoading = ref(false)
onMounted(async()=>{
  isLoading.value = true
  filteredMeta(props.notification.meta)
  isLoading.value = false
})

const meta = ref({})
function filteredMeta(data){
  const filteredData = Object.fromEntries(
    Object.entries(data).filter(([key]) => key !== 'name' && !key.includes('_id'))
  );
  meta.value = filteredData
}
</script>

<template>
  <div class="m-2">
    <LoadingCard v-if="isLoading" />
    <div v-else>
      <template v-if="notification.entity_type.attributes.entity != 'assessment'">
        <div>
          <p class="mb-1" v-for="(val, key) in meta">
            <!-- <p>{{ meta }}</p> -->
            <span class="fw-semibold tracking-wide">{{ humanizeText(key) }} :</span> 
            {{ val }}
          </p>
        </div>
      </template>
      <levelupCard v-else :notification="notification"/>
    </div>
  </div>
</template>